import { ChangeEvent, useState } from 'react';

export default function useInput(initialValue: string | undefined) {
  const [value, setValue] = useState(initialValue);

  const onChange = (e: ChangeEvent<{ name?: string | undefined; value: unknown }>) => {
    const target = e.target as HTMLInputElement | null;
    target && setValue(target.value);
  };

  return {
    value,
    onChange,
  };
}
